import gql from 'graphql-tag'

export default gql`
mutation hookTracking($labelId: String!, $trackingId: String!) {
  hookTracking(labelId: $labelId, trackingId: $trackingId) {
    _id
    sendHook
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/hookTracking.js